/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type personalizedFiltersHelpers_shippingFilters$ref = any;
export type personalizedFiltersHelpers_shippingFilters = ReadonlyArray<{
    readonly totalCount: number | null;
    readonly " $refType": personalizedFiltersHelpers_shippingFilters$ref;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "personalizedFiltersHelpers_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalCount",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '4ce009729efa2bb5edc0685db84567ae';
export default node;
